export default "__VITE_ASSET__Dj32aO6$__"